/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 共通管理フラグ - USER:ユーザ - COMMON: 標準 
 * @export
 * @enum {string}
 */

export const CommonManagementFlag = {
    User: 'USER',
    Common: 'COMMON'
} as const;

export type CommonManagementFlag = typeof CommonManagementFlag[keyof typeof CommonManagementFlag];



